import React, { useState } from 'react';

import ReCaptcha from '../ReCaptcha';
import TextField from '../TextField';
import TextArea from '../TextArea';
import Modal from '../Modal';

import Gap from '../Gap';

import { Spinner } from '@zendeskgarden/react-loaders';

import '@zendeskgarden/react-buttons/dist/styles.css';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [recaptcha, setReCaptcha] = useState('');
  const [showValidation, setShowValidation] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const getValidation = () => {
    return {
      name: name.length < 1 ? 'Name must contain at least one character' : null,
      email: email.length < 1 ? 'Please specify a valid email adress' : null,
      message: message.length < 1 ? 'Please specify a valid message' : null,
      recaptcha: !recaptcha
        ? 'Please confirm that you are not a robot (anti spam)'
        : '',
    };
  };

  const onSubmit = () => {
    if (Object.values(getValidation()).filter(Boolean).length > 0) {
      return setShowValidation(true);
    }

    setIsLoading(true);

    // Track event in Google Analytics
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'Contact',
      eventAction: 'submit',
      eventLabel: 'Contact message submitted',
    });

    window
      .fetch('//api.talallahouse.com/contact-messages', {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          name,
          email,
          message,
          'g-recaptcha-response': recaptcha,
        }),
      })
      .then(response => response.json())
      .then(response => setShowConfirmation(true));
  };

  const validation = getValidation();

  return (
    <div>
      <Modal
        visible={showConfirmation}
        title="We have received your message"
        body={
          <div>
            Thank you for writing us, we will get back to you as soon as
            possible.
            <br />
            <br />
            Warmly,
            <br />
            Talalla House
          </div>
        }
        onSubmit={() => {
          window.location = '/';
        }}
      />
      <TextField
        label="Name"
        id="name"
        onChange={evt => setName(evt.target.value)}
        value={name}
        validation={showValidation && validation.name}
      />
      <Gap />
      <TextField
        label="Email"
        id="email"
        onChange={evt => setEmail(evt.target.value)}
        value={email}
        validation={showValidation && validation.email}
      />
      <Gap />
      <TextArea
        label="Message"
        id="message"
        onChange={evt => setMessage(evt.target.value)}
        value={message}
        validation={showValidation && validation.message}
      />
      <Gap />
      <ReCaptcha
        onChange={token => setReCaptcha(token)}
        validation={showValidation && validation.recaptcha}
      />
      <Gap />
      {isLoading ? (
        <Spinner color="#ee5b44" size="48px" delayMS={0} />
      ) : (
        <button className="button" onClick={onSubmit}>
          Send message
        </button>
      )}
      <Gap />
    </div>
  );
};

export default ContactForm;
